<vw-toast-popup [isOpen]="isOpen" width="100%" borderRadius="24px" customClass="bg-white" (close)="onClose()">
  <div class="flex flex-col gap-3 p-4 pb-6">
    <!-- Ajouter une planche -->
    <button type="button" class="flex items-center gap-3 rounded-2xl border border-gray-100 p-4 text-left" (click)="addBed()">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-primary-50 text-xl">🟫</span>
      <span class="flex-1">
        <span class="block text-base font-semibold text-[#023E42]">{{ 'garden.actions.add-bed.title' | translate }}</span>
        <span class="block text-xs text-[#9BA6A1]">{{ 'garden.actions.add-bed.subtitle' | translate }}</span>
      </span>
      <span class="text-[#9BA6A1]">›</span>
    </button>

    <!-- Planter une plante -->
    <button type="button" class="flex items-center gap-3 rounded-2xl border border-gray-100 p-4 text-left" (click)="addPlant()">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-primary-50 text-xl">🌱</span>
      <span class="flex-1">
        <span class="block text-base font-semibold text-[#023E42]">{{ 'garden.actions.add-plant.title' | translate }}</span>
        <span class="block text-xs text-[#9BA6A1]">{{ 'garden.actions.add-plant.subtitle' | translate }}</span>
      </span>
      <span class="text-[#9BA6A1]">›</span>
    </button>

  </div>
</vw-toast-popup>
